import { SigmaIcon } from './SigmaIcon';

/**
 * author: Google
 * id 59A98F47-9067-492A-8454-42BEFA2391C1
 * name sigma
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/sigma.svg
 * tags
 * - Math 
 */
export const SummationIcon = SigmaIcon;
export default SummationIcon